import React from 'react';
import { RunningLoader } from '@/components/RunningLoader';

interface GeneratingOverlayProps {
    show?: boolean;
}

const GeneratingOverlay: React.FC<GeneratingOverlayProps> = ({ show }) => {
    if (!show) return null;
    return (
        <div className="absolute inset-0 bg-slate-950/70 backdrop-blur-sm flex items-center justify-center text-slate-200">
            <RunningLoader label="AI 生成中" />
        </div>
    );
};

export default GeneratingOverlay;
